// TeamList.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useTeamData } from '../../actions/team/TeamContext';
import TeamItem from './TeamItem';
import TeamWorkSubmissions from './TeamWorkSubmissions';
import { useActionsContext } from '../../context/ActionsContext';
import ENDPOINT from '../../context/EndPoint';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useDispatch } from 'react-redux';


const TeamWorkSubmissionsPage = ({options}) => {
  const dispatch = useDispatch()
    const { rowsPerPage, setRowsPerPage } = useActionsContext(); // Already moved earlier
  
  const [internstasks,setinternstasks ] = useState(null)
  const {user} = useContext(AuthContext)
  
  const fetchAllInternsTasks = async () => {
    dispatch({ type: 'LOADING' }); // Start loading state
  
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('limit', rowsPerPage);
    if (options?.status === 'pending') {
      formData.append('status', options.status);
    }
    // if (options?.limit) {
    //   formData.append('limit', rowsPerPage);
    // }
  
    try {
      const res = await axios.post(ENDPOINT + "admin-get-tasks.php", formData, SecurityHeaders);
  
      if (res?.data) {
        dispatch({ type: 'DONE_LOADING' }); // End loading state only on success
        setinternstasks(res.data);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: 'Invalid response format'
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while fetching interns tasks'
      });
    }
  };

useEffect(()=>{
 fetchAllInternsTasks()
 // console.log("data ",internstasks)
},[rowsPerPage])
  // Use teamData to render team list

  return (
    <div>
    
    {internstasks&&internstasks.data?
    <>
    <TeamWorkSubmissions options={options} Reload={fetchAllInternsTasks} tasks={internstasks.data} />
    </>:
    <>
    
    </>}
   
    </div>
  );
};

export default TeamWorkSubmissionsPage;
